import { useEffect } from "react";
import Sales from '../table/Tablesales';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import Stack from '@mui/material/Stack';
import Modal from "../modal/Modalsales"


const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <Modal/>
    <Sales/>
    
     
     </>
  );
};

export default Dashboard;
